import { useCompactListLayout } from "@/utils/hooks/useCompactListLayout";
import {useParams} from 'react-router-dom';
import {SHARED_ACCESS} from '@/utils/constants/appConstants/SharedAcessConstant';
import { SkeletonBar } from "@/components/skeletons";
import {getUserId} from '@/utils/functions/TokenFunction';
import {useEffect, useState} from 'react';
import {getUserById} from '@/services/user.service';
import { concatenateName } from "@/utils/functions/helperFunctions";

interface ISharedAccessUser {
    users: any[] | null;
    handleUserToggle: any;
    selectedUsers: any[] | null;
    loadingData?: boolean
}

const SharedAccessUserTable = (props: ISharedAccessUser) => {
    const isCompactLayout = useCompactListLayout();
    const [currentUser, setCurrentUser] = useState<any>();
    const params = useParams();
    const user_id = getUserId()

    useEffect(() => {
        getUserById(params.id as string, (res: any) => {
            setCurrentUser(res.data)
        }, (err: any) =>  {
            console.log(err)
        })
    }, [])

    return isCompactLayout ? (
        <div className="envelope_table">
            {props.users!.filter((user) => user.id !== user_id && user.id !== params.id).map((user: any) => (
                <div className="envelope_tr">
                    <div className="icon mr-2  px-2 fs-5">
                        <input type="checkbox" checked={props.selectedUsers!.some((selectedUser: any) => selectedUser.id === user.id)} onChange={() => props.handleUserToggle(user)} />
                    </div>
                    <div className="env_meta_data">
                        <div className="data" style={{ maxWidth: "100%" }}>
                            <div className="info">
                                <div className="info font-weight-bold">
                                    <div className="text-foreground name md:hidden">{concatenateName(user.first_name, user.last_name)}</div>
                                </div>
                                <div className="meta">
                                    <span className="text-foreground">{user.email_address}</span>
                                    <div className="view_env_icon">
                                        <span className="text-foreground">
                                            <span className="font-weight-bold">Shared Access: </span>
                                            <span className="text-foreground">{currentUser?.account_delegate_users.some((delegate: any)=> delegate.user === user.id)? SHARED_ACCESS.YES: SHARED_ACCESS.NO}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    ) : (
        <table className="w-full" style={{ tableLayout: "fixed", width: "100%" }}>
            <thead>
                <tr className="">
                    <th className="" style={{ width: "10%" }}></th>
                    <th className="hidden md:table-cell text-left" style={{ width: "20%" }}>
                        {SHARED_ACCESS.NAME}
                    </th>
                    <th className="hidden md:table-cell" style={{ width: "15%" }}>
                        {SHARED_ACCESS.EMAIL}
                    </th>
                    <th className="hidden md:table-cell text-center" style={{ width: "15%" }}>
                        {SHARED_ACCESS.SHARED_ENVELOPE_ACCESS}
                    </th>
                </tr>
            </thead>
            <tbody className="tb-odr-body">
                {props.users!.filter((user) => user.id !== user_id && user.id !== params.id).map((user: any) => (
                    <tr className="" aria-disabled={user?.account_delegate_users.some((user: any)=> user.user === params.id)? true : false}>
                        <td className="subject-col">
                            <input type="checkbox" checked={props.selectedUsers!.some((selectedUser: any) => selectedUser.id === user.id)} onChange={() => props.handleUserToggle(user)} />
                        </td>
                        <td className="hidden md:table-cell text-left" style={{ maxWidth: "100px" }}>
                            <div className="meta">
                                <span className="text-foreground">{concatenateName(user.first_name, user.last_name)}</span>
                            </div>
                        </td>
                        <td className="hidden md:table-cell text-left" style={{ maxWidth: "100px" }}>
                            <div className="meta">
                                <span className="text-foreground">{user.email_address}</span>
                            </div>
                        </td>
                        <td className="hidden md:table-cell text-center" style={{ maxWidth: "100px" }}>
                            <div className="meta">
                                <span className="text-foreground">{currentUser?.account_delegate_users.some((delegate: any)=> delegate.user === user.id)? SHARED_ACCESS.YES : SHARED_ACCESS.NO}</span>
                            </div>
                        </td>
                    </tr>
                ))}
                <tr>
                    <td colSpan={4} className="text-center">
                        {props.loadingData ? <SkeletonBar /> : null}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default SharedAccessUserTable;
